import { SignupTag } from '@components';
import { useNavigate } from 'react-router-dom';
import { useRegister } from '@coreAuth/useCase';
import { useEffect } from 'react';
import type { IRegister } from '@coreAuth/type';

const Register = () => {
  const navigate = useNavigate();
  const { mutate, isSuccess, isLoading } = useRegister();

  useEffect(() => {
    if (isSuccess) navigate('/dashboard', { replace: true });
  }, [isSuccess]);

  const handleAuth = (registerData: IRegister) => {
    mutate(registerData);
  };

  return (
    <SignupTag
      loading={isLoading}
      authCallback={handleAuth}
      onHaveAcc={() => navigate('/login', { replace: true })}
      onGoogleAuthSuccess={() => navigate('/dashboard', { replace: true })}
    />
  );
};

export default Register;
